import React from 'react';
import styles from './index.module.scss';
import PageSection from '@/tpss/pages/comps/PageSection';
import { IProduct } from '@/tpss/types';
import classNames from 'classnames';
import ProductGroup from '../ProductGroup';

interface ProductListBodyProps {
  products: IProduct[];
}

const ProductListBody: React.FC<ProductListBodyProps> = ({ products }) => {
  // const [categories, setCategories] = useState<string[]>([]);

  // useEffect(() => {
  //   console.log('productlist body use effect');
  //   const categories: string[] = [];
  //   for (let index = 0; index < products.length; index++) {
  //     const product = products[index];
  //     if (!categories.includes(product.ProductCategory)) {
  //       categories.push(product.ProductCategory);
  //     }
  //   }
  //   setCategories(categories);
  //   console.log('categories', categories);
  // }, []);

  function getCatetories() {
    const categories: string[] = [];
    for (let index = 0; index < products.length; index++) {
      const product = products[index];
      if (!categories.includes(product.ProductCategory)) {
        categories.push(product.ProductCategory);
      }
    }
    return categories;
  }

  function getProductsByCategory(category: string) {
    const filteredProducts: IProduct[] = [];
    for (let index = 0; index < products.length; index++) {
      const product = products[index];
      if (product.ProductCategory === category) {
        filteredProducts.push(product);
      }
    }
    return filteredProducts;
  }

  return (
    <PageSection>
      <div className={styles.productCategoryList}>
        <div className={styles.categoryContainer}>
          {getCatetories()?.map((cate) => (
            <div key={cate}>
              <div className={classNames([styles.categoryList])}>
                <div
                  className={classNames([styles.cateName])}
                  // onClick={() => onSelectCategory(cate)}
                >
                  {cate}
                </div>
              </div>
              <ProductGroup products={getProductsByCategory(cate)} />
            </div>
          ))}
        </div>
      </div>
    </PageSection>
  );
};

export default ProductListBody;
